import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { UsersService as SharedUsersService } from '@avanta/shared/services/users';
import { type Psychologist } from '@avanta/shared/types/psychologists';
import { type User } from '@avanta/shared/types/users';
import { type AxiosResponse } from 'axios';
import { getUserId } from 'utils/storage';

const USERS_URL = `${BASE_URL}users`;

interface UserServiceTypes {
  getUser: (userId?: string) => Promise<AxiosResponse<User>>;
  getAllRecentPsychologists: () => Promise<AxiosResponse<Psychologist[]>>;
  sendChatEmailNotification: (
    userRequestId: string,
    userToSendId: string
  ) => Promise<AxiosResponse<void>>;
}

export const UsersService: UserServiceTypes = {
  getUser: SharedUsersService.getUser,
  getAllRecentPsychologists: async () =>
    service.get(`${USERS_URL}/recents/psychologists`, {
      params: { patient_id: getUserId() },
    }),
  sendChatEmailNotification: async (userRequestId, userToSendId) =>
    service.post(`${USERS_URL}/messageSend/email`, {
      user_request_id: userRequestId,
      user_to_send_id: userToSendId,
    }),
};
